var _path, _path2, _circle, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRenyuan8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5a3 3 0 013-3h5a3 3 0 013 3v.5a1 1 0 01-1 1H3a1 1 0 01-1-1v-.5z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10h5V9H5v1zm7.5 2.5v.5h1v-.5h-1zm-.5 1H3v1h9v-1zM2.5 13v-.5h-1v.5h1zm.5.5a.5.5 0 01-.5-.5h-1A1.5 1.5 0 003 14.5v-1zm9.5-.5a.5.5 0 01-.5.5v1a1.5 1.5 0 001.5-1.5h-1zM10 10a2.5 2.5 0 012.5 2.5h1A3.5 3.5 0 0010 9v1zM5 9a3.5 3.5 0 00-3.5 3.5h1A2.5 2.5 0 015 10V9z",
    fill: "#3F465C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 5,
    r: 2.5,
    fill: "#3F465C",
    stroke: "#3F465C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.334 5.831a.5.5 0 100 1v-1zm2.666 1a.5.5 0 000-1v1zm-2.666 0H15v-1h-2.666v1z",
    fill: "#3F465C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 4.998a.5.5 0 10-1 0h1zm-1 2.667a.5.5 0 001 0h-1zm0-2.667v2.667h1V4.998h-1z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_renyuan8.8191bde9.svg";
export { SvgTongyongRenyuan8 as ReactComponent };